'use client';
import { jsx } from 'react/jsx-runtime';
import { renderWithRef } from '../core/render-with-ref.js';
import { RenderComp } from '../core/render-comp.component.js';

const LinkListHeading = renderWithRef('LinkListHeading', null, (i, n)=>jsx(RenderComp, {
        root: "h3",
        forwardedRef: n,
        classNames: [
            'swan-link-list-heading'
        ],
        props: i,
        children: i.children
    }));

export { LinkListHeading };
